"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var LimitsList_1 = __importDefault(require("./LimitsList"));
var GameLimits = function (_a) {
    var limits = _a.limits;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _b = (0, react_1.useState)(null), addLimits = _b[0], setAddLimits = _b[1];
    var closeAddLimits = (0, react_1.useCallback)(function () {
        setAddLimits(null);
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description },
            react_1.default.createElement(LimitsList_1.default, { limits: limits })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonsContainer },
            react_1.default.createElement(ui_components_1.FixedButton, { variant: "outline", color: "black", onClick: function () {
                    setAddLimits('deposit');
                } }, t('addDepositLimits')),
            react_1.default.createElement(ui_components_1.FixedButton, { variant: "outline", color: "black", onClick: function () {
                    setAddLimits('loss');
                } }, t('addLossLimits')),
            react_1.default.createElement(ui_components_1.FixedButton, { variant: "outline", color: "black", onClick: function () {
                    setAddLimits('bet');
                } }, t('addBetLimits')))));
};
exports.default = GameLimits;
